var React = require('react');
var PropTypes = React.PropTypes;
import ReactDOM from 'react-dom';
import RaisedButton from 'material-ui/RaisedButton';
var CollectionRes = require('../../../resources/collection');
var ConceptRes = require('../../../resources/concept');
var Auth = require('../../../resources/auth');
var Helpers = require('../../../utils/helpers');
import QuestionContent from '../../QuestionContent/QuestionContent';
import CollectionCommentList from '../Review/CollectionCommentList';
import ReviewQuestion from '../Review/ReviewQuestion';
import { browserHistory } from 'react-router';
var $ = require('jquery');
import CollectionInfoRow from '../CollectionInfoRow';
import createConfirm from '../../Modal/createConfirm';
import notification from '../../Modal/notification';

var ViewCollection = React.createClass({

  retrieveCollectionWithTask: function(callback) {
    callback = callback || function(){};
    var _this = this;
    var collectionId = this.props.params.collectionId;
    var options = {
      query: {"include": "review_task"},
      collectionId: collectionId
    }
    CollectionRes.retrieveSingleCollection(options, function(err, res) {
      if (!err && res) {
        var reviewTaskData = _this.transformCollectionData2TaskData(res);
        _this.setState({
          isLoading: false,
          reviewTaskData: reviewTaskData
        }, function() {
          return callback();
        })
      } else {
        _this.setState({
          isLoading: false
        }, function() {
          return callback();
        })
      }
    })
  },

  transformCollectionData2TaskData: function(collectionData) {
    var result = {
      contentInfo: collectionData
    }
    return result;
  },

  retrieveConceptsMap: function(reviewData, callback) {
    callback = callback || function(){};
    reviewData = reviewData || this.state.reviewTaskData;
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      if (err) return;
      reviewData.contentInfo = ConceptRes.buildConceptToCollectionData(reviewData.contentInfo, conceptsMap);
      _this.setState({
        reviewTaskData: reviewData,
        isLoading: false,
        conceptsMap: conceptsMap
      }, function() {
        return callback();
      })
    })
  },

  validateReviewStat: function() {
    /*
    * Valid to Approve: all question marked as Approve
    * Valid to send back Revision: at least 1 question marked as Need Review
    */
    var isValidToApprove = true,
        isValidToReview = false;
    var collection = this.state.reviewTaskData.contentInfo;
    for (var i = 0; i < collection.questions.length; i++) {
      var kquestion = collection.questions[i].kquestion;
      var latestComments = kquestion.reviewComments[kquestion.reviewComments.length-1];
      for (var j = 0; j < latestComments.length; j++) {
        if (latestComments[j].type === 'COLLECTION_KQUESTIONS_ADMIN_REVIEW') {
          // if (latestComments[j].reviewScore === 2) isValidToApprove = false;
          // else if (latestComments[j].reviewScore === 1) isValidToReview = false;
          if (latestComments[j].reviewScore === 2) {
            isValidToApprove = false;
            isValidToReview = true;
          }
        }
      }
      // var latestStat = kquestion.reviewStats[kquestion.reviewStats.length-1];
      // if (latestStat.n > 0)
      //   isValidToApprove = false;
      // if (latestStat.a > 0)
      //   isValidToReview = false;
    }
    return {
      approve: isValidToApprove,
      review: isValidToReview
    }
  },

  approveCollection: function() {
    var collection = this.state.reviewTaskData.contentInfo;
    var isValid = this.validateReviewStat().approve;
    if (isValid) {
      $("body").addClass('heavy-load');
      collection.status = 'complete';
      CollectionRes.updateCollectionOnly(collection, function(err, res) {
        $("body").removeClass('heavy-load');
        // if (err) return alert('Cannot Approve Collection. Please try again');
        if (err) return notification.open({
          message: 'Error',
          description: 'Cannot Approve Collection. Please try again'
        })
        // alert('Collection Approved');
        notification.open({
          message: 'Success',
          description: 'Collection Approved'
        })
        browserHistory.push('/collections')
      })
    }
    else
      // return alert("There is at least 1 question need to be reviewed. Please make sure all questions are approved before approving the whole collection.");
      return notification.open({
        message: 'Error',
        description: "There is at least 1 question need to be reviewed. Please make sure all questions are approved before approving the whole collection.",
        duration: 10
      })
  },

  sendBackCollection: function() {
    var collection = this.state.reviewTaskData.contentInfo;
    var isValid = this.validateReviewStat().review;
    if (isValid) {
      $("body").addClass('heavy-load');
      collection.status = 'need_revisions';
      CollectionRes.updateCollectionOnly(collection, function(err, res) {
        $("body").removeClass('heavy-load');
        if (err) return notification.open({
          message: 'Error',
          description: "Process fail. Please try again"
        })
        // alert('The colllection has been sent back to the Teacher for revision');
        notification.open({
          message: 'Success',
          description: "The colllection has been sent back to the Teacher for revision"
        })
        browserHistory.push('/collections')
      })
    }
    else return notification.open({
      message: 'Error',
      description: 'There is no question marked as "Need Review". Please try again'
    });
  },

  rejectCollection: function() {
    this.setState({openConfirm: true});
    this.confirmable = createConfirm({
      title: "CONFIRM",
      content: "Are you sure you want to reject this collection?"
    }, () => {
      this.setState({openConfirm: false});
      var collection = this.state.reviewTaskData.contentInfo;
      $("body").addClass("heavy-load");
      collection.status = "rejected";
      CollectionRes.updateCollectionOnly(collection, function(err, res) {
        if (err) return alert('Cannot reject this collection. Please try again');
        var options = {}
        options.collectionId = collection._id 
        options.body = {
          status: 'self'
        }
        if(collection.questions.length !== 0){
          CollectionRes.updateAllKquestionInCollection(options, function(err, res) {
            $("body").removeClass('heavy-load');
            console.log('err-res', err, res)
            if (err) return alert('Cannot reject this collection. Please try again');
            // alert('You have successfully rejected the collection');
            notification.open({
              message: 'Success',
              description: "You have successfully rejected the collection"
            })
            browserHistory.push('/collections')
          })
        }else {
          $("body").removeClass('heavy-load');
          notification.open({
            message: 'Success',
            description: "You have successfully rejected the collection"
          })
          browserHistory.push('/collections')
        }
      })
    }, () => {
      this.setState({openConfirm: false});
    })
    // var r = confirm("Are you sure you want to reject this collection?");
    // if (!r) return;
    // var collection = this.state.reviewTaskData.contentInfo;
    // $("body").addClass("heavy-load");
    // collection.status = "rejected";
    // CollectionRes.updateCollectionOnly(collection, function(err, res) {
    //   $("body").removeClass('heavy-load');
    //   if (err) return alert('Cannot reject this collection. Please try again');
    //   alert('You have successfully rejected the collection');
    //   browserHistory.push('/collections')
    // })
  },

  updateOtherReviewTasks: function() {
    this.setState({
      updateOtherReviewTasksCount: this.state.updateOtherReviewTasksCount + 1
    }, () => {
      if (this.state.updateOtherReviewTasksCount < this.state.reviewTaskData.contentInfo.questions.length) return;
      var taskData = this.state.reviewTaskData,
          currentRound = taskData.contentInfo.current_review_round,
          currentRoundIndex = currentRound - 1;
      taskData.currentRoundStat = {a: 0, n: 0};
      var currentUser = Auth.getCurrentUser();
      for (var i = 0; i < taskData.contentInfo.questions.length; i++) {
        var kquestion = taskData.contentInfo.questions[i].kquestion;
        for (var j = 0; j < kquestion.reviewTasks.length; j++) {
          var task = kquestion.reviewTasks[j];
          if (task.reviewRound !==  taskData.contentInfo.current_review_round) continue;
          if (currentUser.role === 'admin') {
            if (task.type === 'COLLECTION_KQUESTIONS_ADMIN_REVIEW') {
              if (task.reviewScore === 1) taskData.currentRoundStat.a += 1;
              else if (task.reviewScore === 2) taskData.currentRoundStat.n += 1;
            }
          } else if (task.reviewer === currentUser._id) {
            if (task.type === "COLLECTION_KQUESTIONS_REVIEW") {
              if (task.reviewScore === 1) taskData.currentRoundStat.a += 1;
              else if (task.reviewScore === 2) taskData.currentRoundStat.n += 1;
            }
          }
        }
      }
      this.setState({
        reviewTaskData: taskData
      })
    });
  },

  getInitialState: function() {
    return {
       reviewTaskData: {
         contentInfo: {
           questions: []
         }
       },
       conceptsMap: null,
       isLoading: false,
       updateOtherReviewTasksCount: 0
    };
  },

  componentWillMount: function() {

  },

  componentWillReceiveProps: function(nextProps) {

  },

  render: function() {
    var _this = this,
        taskData = this.state.reviewTaskData,
        conceptsMap = this.state.conceptsMap,
        currentUser = Auth.getCurrentUser(),
        isAdmin = currentUser.role === 'admin',
        statusForView = ['complete', 'rejected', 'published', 'need_revisions'],
        // mode = isAdmin ? 'admin-view' : 'view',
        mode = isAdmin && statusForView.indexOf(taskData.contentInfo.status) < 0 ? 'admin-view' : 'view';
        // canShowAdminAction = isAdmin && taskData.contentInfo.status !== 'complete';
    
    var collectionData = taskData.contentInfo;
    for (var i in collectionData.questions) {
      var question = collectionData.questions[i];
      var isNeedRevision = false;
      for (var k in question.kquestion.reviewTasks) {
        var reviewTask = question.kquestion.reviewTasks[k];
        if (collectionData.current_review_round === reviewTask.reviewRound && currentUser.role === 'admin' && reviewTask.type === 'COLLECTION_KQUESTIONS_ADMIN_REVIEW' && reviewTask.reviewScore === 2) isNeedRevision = true;
        else if (reviewTask.reviewScore === 2 && collectionData.current_review_round === reviewTask.reviewRound) isNeedRevision = true;
      }
      question.isNeedRevision = isNeedRevision;
    }

    return (
      <div className="review-collection-container">
        {this.state.openConfirm && this.confirmable}
        <div className="content-toolbar">
          {
            mode === 'admin-view' && <h3>Review Collection</h3>
          }
          {
            mode === 'view' && <h3>View Collection</h3>
          }
          {
            mode === 'admin-view' &&
            <div className="btn-holder">
              <RaisedButton
                label="Reject this Collection"
                backgroundColor="#EF5350"
                labelStyle={{color: "white"}}
                icon={<i className="fa fa-remove" style={{color: "white"}}></i>}
                onClick={this.rejectCollection}
              />
              <RaisedButton
                label="Send back to setter for Revision"
                secondary={true}
                icon={<i className="fa fa-refresh" style={{color: "white"}}></i>}
                onClick={this.sendBackCollection}
              />
              <RaisedButton
                label="Approve"
                primary={true}
                icon={<i className="fa fa-thumbs-o-up" style={{color: "white"}}></i>}
                onClick={this.approveCollection}
              />
            </div>
            
          }
          {
            mode === 'admin-view' &&
            <p className="txt-primary text-left" style={{fontSize: "13px", paddingTop: "10px"}}>
              <i>* {'"REJECT THIS COLLECTION": The current collection will be rejected and moved to "Rejected" tab'}</i><br/>
              <i>* {'"SEND BACK TO SETTER FOR REVISION": The current collection will be sent back to setter to modify and moved to "Need Revision" tab'}</i><br/>
              <i>* {'"APPROVE": The current collection will be approved and moved to "Completed" tab'}</i><br/>
            </p>
          }
        </div>
        <hr className="margin-bottom-10"/>
        <h3
          className="margin-top-10"
          style={{fontSize: "20px", color: "#555"}}>
          {taskData && taskData.contentInfo && taskData.contentInfo.title}
        </h3>
        <div className="row margin-bottom-10">
          <div className="col-md-8">
            <CollectionInfoRow
              conceptsMap={conceptsMap}
              data={taskData.contentInfo}/>
            <div className="text-center">
              <div className="review-info dp-inline-block">
                <span className="txt-primary padding-right-15">
                  {'Approve: ' + (taskData.currentRoundStat ? taskData.currentRoundStat.a : '-')}
                </span>
                <span className="txt-danger">
                  {'Need Review: ' + (taskData.currentRoundStat ? taskData.currentRoundStat.n : '-')}
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="collection-info text-center">
              <span className="txt-secondary"><b>Reviews</b></span>
            </div>
          </div>
        </div>
        {
          conceptsMap && taskData.contentInfo.questions.length > 0 && (
            taskData.contentInfo.questions.map(function(question, index) {
              return (
                <div key={index} className="review-collection row" style={{
                  display: 'flex',
                  backgroundColor: question.isNeedRevision ? 'bisque' : null
                }}>
                  <div className="content-play col-md-8">
                    <QuestionContent
                      questions={[question]}
                      questionIndex={index}
                      conceptLeafMapping={_this.state.conceptsMap}/>
                  </div>
                  <div className="review-content col-md-4">
                    <ReviewQuestion
                      question={question}
                      reviewTaskData={taskData}
                      taskMode={mode}
                      updateOtherReviewTasks={_this.updateOtherReviewTasks}/>
                  </div>
                </div>
              )
            })
          )
        }
        {
          taskData.contentInfo._id &&
          <CollectionCommentList
            reviewTaskData={taskData}
            taskMode={mode}
          />
        }
      </div>
    );
  },

  componentDidMount: function() {
    var _this = this;
    _this.setState({
      isLoading: true
    }, function() {
      _this.retrieveCollectionWithTask(function() {
        _this.retrieveConceptsMap();
      });
    })
  },

  componentDidUpdate: function(prevProps) {
    var _this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  },

});

module.exports = ViewCollection;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/View/ViewCollection.js
 **/